import { VuexHelper } from '@amarkets/atlas/esm/lib/vuex-helper';
import createActions from './second-factor/actions';
import state from './second-factor/state';
import mutations from './second-factor/mutations';
import getters from './second-factor/getters';

export default function (context) {
  return VuexHelper.createStoreModule({
    states: [state],
    actions: [createActions(context)],
    mutations: [mutations],
    getters: [getters],
  });
}
